import React from 'react';
import { string, shape, func, number } from 'prop-types';

import IconClose from '../../icons/sources/close';
import { useShowShimmerAction } from '../../../components/context/full-freeshipping';
import useIconEshopsWrapper from '../hooks/use-icon-eshops-wrapper';
import IconSection from './components/icon-section';
import TextSection from './components/text-section';
import ActionButtonSection from './components/action-button-section';

const namespace = 'ui-search-fullsnackbar';

/**
 * FullShippingInfoContent component
 *
 * @component
 * @param {Object} props
 * @param {string} props.assetUrl - URL of the e-shop icon image
 * @param {Function} props.closeAction - Function to handle close action
 * @param {Object} props.epigraph - Epigraph configuration
 * @param {string} props.firstText - First text to display
 * @param {string} props.lastText - Last text to display
 * @param {Object} props.progressBar - Progress bar configuration
 * @param {Object} props.title - Title configuration
 * @param {Object} props.action_button - Action button configuration
 * @param {Object} props.action_logo - Action logo configuration
 * @returns {React.ReactElement} The full shipping info content component
 */

const FullShippingInfoContent = ({
  assetUrl,
  closeAction,
  epigraph,
  firstText,
  lastText,
  progressBar,
  title,
  action_button,
  action_logo,
}) => {
  const showShimmerAction = useShowShimmerAction();
  const wrapIcon = useIconEshopsWrapper(action_logo, showShimmerAction);

  return (
    <>
      <div className={`${namespace}__main`}>
        <div className={`${namespace}__icon-text-container`}>
          <IconSection assetUrl={assetUrl} title={title} progressBar={progressBar} wrapIcon={wrapIcon} />
          <TextSection
            title={title}
            firstText={firstText}
            lastText={lastText}
            progressBar={progressBar}
            epigraph={epigraph}
          />
        </div>
        <ActionButtonSection showShimmerAction={showShimmerAction} action_button={action_button} />
      </div>
      {closeAction && (
        <button className={`${namespace}__close`} onClick={closeAction} type="button" tabIndex={0}>
          <span className="sr-only">{}</span>
          <IconClose />
        </button>
      )}
    </>
  );
};

FullShippingInfoContent.propTypes = {
  action_button: shape({
    text: string,
    permalink: string,
  }),
  action_logo: shape({
    permalink: string,
  }),
  assetUrl: string,
  closeAction: func,
  epigraph: shape({
    first_text: string,
    last_text: string,
  }),
  firstText: string,
  lastText: string,
  progressBar: shape({
    percent: number,
    color: string,
    color_hex: string,
  }),
  title: shape({
    first_text: string,
    last_text: string,
    asset_image: string,
  }),
};

export default FullShippingInfoContent;
